<template>
    <div>
         <CodeEditor
                v-model="content.expression"
                :withButton="false"
                :label="this.$t('code')"
                :label-cols="1"
                :options="{
                    mode: 'javascript', 
                    showFullscreenButton: true,
                    title: nodeName,
                    enableProtokolTypes: true  // This will load Protokol SDK types
                }"
                :height="editorHeight"
            />
    </div>
</template>

<script>
import InputField from '@/components/form/Input'
import CodeEditor from '@/components/form/Editor/Code'

export default {
    components: {
        InputField,
        CodeEditor
    },
    props: {
       value: {
         type: Object
       },

       nodeName: {
         type: String
       },

       editorHeight: {
         type: Number,
         default: 600
       }
    },
    computed: {
        content: {
            get() {
                return this.value || {};
            },

            set(val) {
                this.$emit('input', val);
            }
        },

         libs() {
            return [
                {
                    name: "lodash",
                    varName: "_",
                    docs: "https://lodash.com/"
                },
                {
                    name: "moment",
                    varName: "moment",
                    docs: "https://momentjs.com"
                },
                {
                    name: "protokol",
                    varName: "*",
                    docs: this.$env.get('DOCS_URL') + "/libs/workflow/io"
                }
            ]
        },

        vars() {
            return [
                {
                    name: "models",
                    usage: `[ collection of models from event ]`
                },
                {
                    name: "model",
                    usage: `first model in models`
                },
            ]
        }
    },
    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        save() {
            this.modal.show = false
            this.content = {
                to: this.to,
                subject: this.subject,
                body: this.body
            }
        }
    },
    data: function() {
        return {
            errors: [],
            modal: {
                show: false
            },

            snippets: [
                {text: 'io.getPipedDataOf(nodeName)', displayText: 'io.getPipedDataOf(nodeName)', info: 'Get piped data of another node that executed before this node.', docs: this.$env.get('DOCS_URL') + "/docs#libs-io"},
                {text: 'io.pipe(data)', displayText: 'io.pipe(data)', info: `Pipe data so other nodes that executes after this node can use it.`, docs: this.$env.get('DOCS_URL') + "/docs#libs-io"}
            ]
        }
    },

    mounted() { }
}
</script>
